import eventsAuthNames from '../events/auth';
import { useSendEvent } from '../useSendEvent';

const useSiteVisitDemoUser = () =>
	useSendEvent(eventsAuthNames.siteVisitDemoUser, undefined, {
		forceSendNoUser: true,
	});

const annalsAuth = {
	useSiteVisitDemoUser,
};

export default annalsAuth;
